module.exports = __webpack_public_path__ + "static/media/copy.eb51a8bb.svg";